import { Component, OnInit } from '@angular/core';
import { Capacitor } from '@capacitor/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Organization } from 'src/app/classes/organization';
import { SettingsService } from 'src/app/services/settings.service';
import { environment } from 'src/environments/environment';
import { LanguageSelectorComponent } from '../../common/language-selector/language-selector.component';
import { TncComponent } from '../../common/tnc/tnc.component';
import { PrivacyPolicyComponent } from '../../common/privacy-policy/privacy-policy.component';
import * as fa from '@fortawesome/free-solid-svg-icons';

import locales from 'src/app/constants/locales';

@Component({
  selector: 'app-order',
  templateUrl: './order.component.html',
  styleUrls: ['./order.component.scss'],
})
export class OrderComponent implements OnInit {

  copyrightYear = new Date().getFullYear()
  environment = environment
  fa = fa
  locale = $localize.locale
  locales = locales
  organization = new Organization()
  platform = Capacitor.getPlatform()

  constructor(
    private settingsService: SettingsService,
    private modalService: NgbModal
  ) { }

  ngOnInit() {
    // Fetch organization information
    this.settingsService.organizationPublic().subscribe(organization => {
      this.organization = organization
    })
  }

  languageSelector() {
    const modal = this.modalService.open(LanguageSelectorComponent, { centered: true, size: 'md' })
  }

  tnc() {
    const modal = this.modalService.open(TncComponent, { centered: true, size: 'lg' })

    modal.componentInstance.organization =
      modal.componentInstance.showAccept = false
  }

  privacyPolicy() {
    const modal = this.modalService.open(PrivacyPolicyComponent, { centered: true, size: 'lg' })
  }
}
